module.exports = __webpack_public_path__ + "img/about/80243-019.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-019.png
// module id = 16
// module chunks = 0